import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Spin, ConfigProvider } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

// project import
import Routes from "routes";
import ThemeCustomization from "themes";
import ScrollTop from "@shared/components/ScrollTop";

// ==============================|| APP - THEME, ROUTER ||============================== //

const loadingIcon = <LoadingOutlined style={{ fontSize: 48 }} spin />;

const loading = (
  <div className="flex items-center justify-center min-h-screen bg-gray-50">
    <Spin indicator={loadingIcon} />
  </div>
);

const App = () => {
  return (
    <ConfigProvider>
      <BrowserRouter>
        <React.Suspense fallback={loading}>
          <ThemeCustomization>
            <ScrollTop>
              <Routes />
            </ScrollTop>
          </ThemeCustomization>
        </React.Suspense>
      </BrowserRouter>
    </ConfigProvider>
  );
};

export default App;
